var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 18.3337C2.75001 18.3337 2.41667 18.167 2.08334 17.917C1.66667 17.5003 1.58334 16.917 1.75001 16.417L2.58334 13.8337C2.00001 12.667 1.66667 11.3337 1.66667 10.0003C1.66667 5.41699 5.41667 1.66699 10 1.66699C14.5833 1.66699 18.3333 5.41699 18.3333 10.0003C18.3333 14.5837 14.5833 18.3337 10 18.3337C8.66667 18.3337 7.33334 18.0003 6.16667 17.417L3.58334 18.2503C3.50001 18.3337 3.33334 18.3337 3.16667 18.3337ZM6.66667 15.7503C7.66667 16.3337 8.83334 16.667 10 16.667C13.6667 16.667 16.6667 13.667 16.6667 10.0003C16.6667 6.33366 13.6667 3.33366 10 3.33366C6.33334 3.33366 3.33334 6.33366 3.33334 10.0003C3.33334 11.167 3.66667 12.3337 4.25 13.3337C4.33334 13.5003 4.41667 13.7503 4.33334 14.0003L3.50001 16.5837L6.08334 15.7503C6.08334 15.7503 6.58517 15.7096 6.66667 15.7503Z",
    fill: "#505054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.3337C10.7364 11.3337 11.3333 10.7367 11.3333 10.0003C11.3333 9.26395 10.7364 8.66699 10 8.66699C9.26363 8.66699 8.66667 9.26395 8.66667 10.0003C8.66667 10.7367 9.26363 11.3337 10 11.3337Z",
    fill: "#505054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91666 11.3337C6.65304 11.3337 7.24999 10.7367 7.24999 10.0003C7.24999 9.26395 6.65304 8.66699 5.91666 8.66699C5.18028 8.66699 4.58333 9.26395 4.58333 10.0003C4.58333 10.7367 5.18028 11.3337 5.91666 11.3337Z",
    fill: "#505054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 11.3337C14.8197 11.3337 15.4167 10.7367 15.4167 10.0003C15.4167 9.26395 14.8197 8.66699 14.0833 8.66699C13.347 8.66699 12.75 9.26395 12.75 10.0003C12.75 10.7367 13.347 11.3337 14.0833 11.3337Z",
    fill: "#505054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.e4f3376bac240bc30dc8716c1914fe8f.svg";
export { ForwardRef as ReactComponent };